var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesassigner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 18,
    viewBox: "0 0 34 18",
    fill: "#1F2937",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1914 6.73507L18.6996 5.45916L17.8277 3.19658C17.0791 1.25457 15.2937 0 13.2781 0H7.72187C5.70675 0 3.92088 1.25457 3.17231 3.19658L2.30038 5.45916L1.80862 6.73507C0.753375 7.15144 0 8.20305 0 9.44444V11.6239C0 12.3559 0.2695 13.0165 0.7 13.5278V15.9829C0.7 16.7852 1.32694 17.4359 2.1 17.4359H3.5C4.27306 17.4359 4.9 16.7852 4.9 15.9829V14.5299H16.1V15.9829C16.1 16.7852 16.7269 17.4359 17.5 17.4359H18.9C19.6731 17.4359 20.3 16.7852 20.3 15.9829V13.5278C20.7305 13.017 21 12.3563 21 11.6239V9.44444C21 8.20305 20.2466 7.15144 19.1914 6.73507V6.73507ZM5.77194 4.27588C6.09087 3.44858 6.86306 2.90598 7.72187 2.90598H13.2781C14.1369 2.90598 14.9091 3.44858 15.2281 4.27588L16.1 6.53846H4.9L5.77194 4.27588ZM3.5 11.6149C2.66 11.6149 2.1 11.0355 2.1 10.1664C2.1 9.29733 2.66 8.71795 3.5 8.71795C4.34 8.71795 5.6 10.0216 5.6 10.8906C5.6 11.7597 4.34 11.6149 3.5 11.6149ZM17.5 11.6149C16.66 11.6149 15.4 11.7597 15.4 10.8906C15.4 10.0216 16.66 8.71795 17.5 8.71795C18.34 8.71795 18.9 9.29733 18.9 10.1664C18.9 11.0355 18.34 11.6149 17.5 11.6149V11.6149Z",
    fill: "#1F2937"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    y1: 7.73077,
    x2: 32.5,
    y2: 7.73077,
    stroke: "#1F2937",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesassigner);
export default __webpack_public_path__ + "static/media/desassigner.eaf3a8d09427760f71c29993f1ac8e87.svg";
export { ForwardRef as ReactComponent };